import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AgentViewActivityBtn } from "../common-styling";
import SpinnerButton from "../spinner-button/spinner-button";

const ActivityButton = ({
  ACTIVITY_RESULT_TYPE,
  currentActivityLoader,
  isDisabled,
  activityHandler,
  ACTIVITY_TYPE,
  btnText,
  btnStyle,
  icon,
  btnTextPrimary,
  variant = "primary",
  funnelAppointment = false,
  appointmentDialog,
  comment,
  className,
  responses,
  disabledTooltip = ""
}) => {
  const action = () => {
    if (funnelAppointment) {
      appointmentDialog();
    } else {
      activityHandler({
        type: ACTIVITY_TYPE,
        result: ACTIVITY_RESULT_TYPE,
        comment,
        responses
      });
    }
  };
  if (currentActivityLoader[ACTIVITY_RESULT_TYPE]) {
    return <SpinnerButton btnText={btnText} btnStyle={btnStyle} />;
  }

  const activityButton = (
    <AgentViewActivityBtn
      variant={variant}
      className={className}
      disabled={isDisabled}
      onClick={action}
    >
      {icon && <FontAwesomeIcon icon={icon} className="ms-1 me-2" />}
      {btnTextPrimary}
    </AgentViewActivityBtn>
  );

  return isDisabled && disabledTooltip ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{disabledTooltip}</Tooltip>}
    >
      <span className="d-inline-block w-100">{activityButton}</span>
    </OverlayTrigger>
  ) : (
    activityButton
  );
};

export default ActivityButton;
